<template>
  <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" 
  :loading="modalLoading" closable mask-closable :okText="getTranslation('c006')" :cancelText="getTranslation('b182')" :title="title"
  width="40">
    <Row class="field-line" type="flex">
      <Col flex="1" class="desc-field">
      {{ getTranslation('k259') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.spotId" type="number" />
      </Col>
      <Col flex="1" class="desc-field">
      {{ getTranslation('k241') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.spotName" maxlength="50" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="1" class="desc-field">
      {{ getTranslation('b006') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.spotProg" type="number" />
      </Col>
      <Col flex="1" class="desc-field">
      {{ getTranslation('k243') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.spotPss" type="number" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="1" class="desc-field">
      {{ getTranslation('k244') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.spotThk" type="number" />
      </Col>
      <Col flex="1" class="desc-field">
      {{ getTranslation('k245') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.spotModel" maxlength="60" />
      </Col>
    </Row>

    <Row class="field-line" type="flex">
      <Col flex="1" class="desc-field">
      {{ getTranslation('k379') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.spotX" type="number" />
      </Col>
      <Col flex="1" class="desc-field">
      {{ getTranslation('k380') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.spotY" type="number" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="1" class="desc-field">
      {{ getTranslation('k381') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.spotZ" type="number" />
      </Col>
      <Col flex="3" class="desc-field">
      </Col>

    </Row>
    <Row class="field-line" type="flex">
      <Col flex="1" class="desc-field">
      {{ getTranslation('k247') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.plateName1" maxlength="40" />
      </Col>
      <Col flex="1" class="desc-field">
      {{ getTranslation('k248') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.plateThk1" type="number" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="1" class="desc-field">
      {{ getTranslation('k249') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.plateName2" maxlength="40" />
      </Col>
      <Col flex="1" class="desc-field">
      {{ getTranslation('k250') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.plateThk2" type="number" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="1" class="desc-field">
      {{ getTranslation('k251') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.plateName3" maxlength="40" />
      </Col>
      <Col flex="1" class="desc-field">
      {{ getTranslation('k252') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.plateThk3" type="number" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="1" class="desc-field">
      {{ getTranslation('k253') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.plateName4" maxlength="40" />
      </Col>
      <Col flex="1" class="desc-field">
      {{ getTranslation('k254') }}
      </Col>
      <Col flex="2">
      <Input v-model="prodspot.plateThk4" type="number" />
      </Col>
    </Row>
    <div slot="footer">
        <Row type="flex" class="menu-actions flex-right">
          <Col flex="1" >
            <Button type="text" @click="cancel" icon="md-close" >{{ getTranslation('b182') }}</Button>&nbsp;
            <Button type="primary" @click="ok" icon="md-checkmark" >{{ getTranslation('c006') }}</Button>            
          </Col>
        </Row>
      </div>
  </Modal>

</template>
<script>

import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'

export default {
  name: 'ProdspotEdit', // 组件名称
  components: {
    
  },
  props: {
    propVisible: Boolean,
    editId: Number
  },
  data() {
    return {
      prodspot: {},
      title: '',
      modalLoading: true,
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.editId > 0) {
          this.title = this.getTranslation('s034');
          this.getOneProdspot(this.editId)
        } else {
          this.title = this.getTranslation('s033');
          this.prodspot = {}
        }
      }
    }
  },

  created() {
    this.mac = this.$route.query.mac
  },
  methods: {
    getOneProdspot(id) {
      let url = API_URL["prodspotGetOne"];
      let params = {
        id: id
      }

      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.prodspot = res.data.data;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    ok() {
      let _this = this;
      this.modalLoading = true;

      let url = API_URL["prodspotAdd"];
      if (this.editId > 0) {
        url = API_URL["prodspotUpdate"];
      }
      let params = this.prodspot;
      this.prodspot.macId = this.mac
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.$Message.success(res.data.msg);
            this.visible = false
            _this.$emit("refresh-page")
          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
            this.modalLoading = false;
            this.resetModal();
          } else {
            this.$Message.error(this.getTranslation('c001'));
            this.modalLoading = false;
            this.resetModal();
          }
        })
        .catch((err) => {
          postJsError(err)
          this.modalLoading = false;
          this.resetModal();
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    resetModal() {
      this.$nextTick(() => {
        this.modalLoading = true;
      });
    },
    cancel() {
      this.visible = false;
    }
  },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css');
.desc-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 5px;
  font-size: 12px;
}

.field-line {
  margin-bottom: 8px;
}
</style>